/* eslint-disable no-unreachable */
/* eslint-disable jsx-a11y/anchor-is-valid */
import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect, useState } from 'react';
import {
  FaBars,
  FaBriefcase,
  FaBuilding,
  FaChartBar,
  FaChartLine,
  FaComment,
  FaFileUpload,
  FaSignOutAlt,
  FaStar,
  FaTags,
  FaUsers
} from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import rest from '../axios'; // já configurado com axios
import AvaliacoesComponent from '../componente/avaliacoes';
import CategoryComponent from '../componente/categoria';
import CategoriesAdditionalComponent from '../componente/categorias_adicionais';
import PopularItemsComponent from '../componente/categorias_populares';
import ComentariosComponent from '../componente/comentarios';
import CondominiumComponent from '../componente/condominios';
import EstatisticasComponent from '../componente/estatisticas';
import PrestadoresComponent from '../componente/prestadores';
import RatingsReportComponente from '../componente/relatorio';
import SubcategoryComponent from '../componente/subcategoria';
import HistoricComponent from '../componente/trackeamento';
import UserDashboard from '../componente/usuarios';
import './Dashboard.css';
import AnaliticoComponent from '../componente/analitico';


const menuItems = [
  { label: 'Condomínios', icon: <FaBuilding />, page: 'condominios' },
  { label: 'Usuários', icon: <FaUsers />, page: 'usuarios' },
  { label: 'Categoria', icon: <FaTags />, page: 'categoria' },
  { label: 'Subcategoria', icon: <FaTags />, page: 'subcategoria' },
  { label: 'Categoria popular', icon: <FaTags />, page: 'categorias_populares' },
  { label: 'Trackeamento', icon: <FaChartLine />, page: 'trackeamento' },
  { label: 'Analitico', icon: <FaChartLine />, page: 'analitico' },
  { label: 'Categorias Adicionais', icon: <FaTags />, page: 'categorias_adicionais' },
  { label: 'Cadastro em lote', icon: <FaFileUpload />, page: 'lote' },
  { label: 'Prestadores', icon: <FaBriefcase />, page: 'prestadores' },
  { label: 'Avaliações', icon: <FaStar />, page: 'avaliacoes' },
  { label: 'Comentarios', icon: <FaComment />, page: 'comentarios' },
  { label: 'Relatorio das avaliaçoes', icon: <FaStar />, page: 'relatorio' },
  { label: 'Estatísticas', icon: <FaChartBar />, page: 'estatisticas' },
];

const Dashboard = () => {
  const [activePage, setActivePage] = useState('');
  const [email, setEmail] = useState('');
  const navigate = useNavigate(); // aqui

  useEffect(() => {
    const token = localStorage.getItem('token');
    const storedEmail = localStorage.getItem('name');

    if (!token) {
      navigate('/login', {
        state: { message: 'Você precisa fazer login antes de acessar o sistema.' }
      });
      return;
    }

    if (storedEmail) {
      setEmail(storedEmail);
    }
  }, [navigate]);



  const handleLogout = async () => {
    try {
      await rest.post('auth/logout');
    } catch (err) {
      console.warn('Erro ao deslogar:', err);
    }

    localStorage.removeItem('token');
    localStorage.removeItem('name');
    navigate('/login');
  };

  const loadPage = (page) => {
    setActivePage(page);
    const sidebar = document.querySelector('.sidebar');
    if (window.innerWidth <= 768 && sidebar.classList.contains('show')) {
      sidebar.classList.remove('show');
    }
  };


  const renderContent = () => {
    if (activePage === 'condominios') return <CondominiumComponent />;
    if (activePage === 'usuarios') return <UserDashboard />;
    if (activePage === 'categoria') return <CategoryComponent />;
    if (activePage === 'categorias_populares') return <PopularItemsComponent />;
    if (activePage === 'subcategoria') return <SubcategoryComponent />;
    if (activePage === 'estatisticas') return <EstatisticasComponent />;
    if (activePage === 'avaliacoes') return <AvaliacoesComponent />;
    if (activePage === 'comentarios') return <ComentariosComponent />;
    if (activePage === 'prestadores') return <PrestadoresComponent />;
    if (activePage === 'trackeamento') return <HistoricComponent />;
    if (activePage === 'analitico') return <AnaliticoComponent />;
    if (activePage === 'relatorio') return <RatingsReportComponente />;
    if (activePage === 'categorias_adicionais') return < CategoriesAdditionalComponent />;

    return <div className="text-muted">Selecione um item do menu para começar.</div>;
  };

  return (
    <div id="wrapper" className="wrapper">
      <div className="sidebar">
        <div className="top-menu">
          <div className="profile text-center py-3 px-2 bg-white rounded shadow-sm">
            <img
              src="/logo1.png"
              alt="Logo"
              className="img-fluid rounded-circle mb-2"
              style={{ width: '100px', height: '100px', objectFit: 'contain' }}
            />
            <strong className="d-block text-dark">{email || 'Usuário'}</strong>
            <small className="text-muted">Administrador<i className="fa fa-chevron-down"></i></small>
          </div>
          <ul className="list-unstyled mt-4">
            {menuItems.map((item, idx) => (
              <li key={idx}>
                <a href="#" onClick={(e) => {
                  e.preventDefault();
                  loadPage(item.page);
                }}>
                  {item.icon} <span className="ml-2">{item.label}</span>
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div className="bottom-menu">&copy; Conexxi {new Date().getFullYear()}</div>
      </div>

      <div className="content">
        <div className="navbar d-flex justify-content-between align-items-center px-3 py-2">
          <div className="d-flex align-items-center">
            <button className="toggle-btn me-3" onClick={() => document.querySelector('.sidebar').classList.toggle('show')}>
              <FaBars />
            </button>
            <span className="welcome-text fw-bold">Bem-vindo à Conexxi! Estamos de cara nova.</span>
          </div>
          <button
            className="btn btn-outline-danger d-flex align-items-center"
            onClick={handleLogout}
          >
            <FaSignOutAlt className="me-2" /> Logout
          </button>

        </div>

        <div id="main-content" className="p-4">
          {renderContent()}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
